<script setup>
import { ref, onMounted, watch } from "vue";
import Input from "@/Components/Settings/Input.vue";
import TD from "@/Components/Table/Element.vue";
import axios from "axios";
import debounce from "lodash/debounce";

const props = defineProps({
    stati: Array,
    currentStatus: Number,
});

const emit = defineEmits(["selectStatus"]);

const showResults = ref(false);
const input = ref(null);
const icon = ref('transparent');
const inpval = ref("");

function selectStatus(status, index) {
    emit("selectStatus", index);
    showResults.value = false;
    inpval.value = status.text;
    input.value.blur();
    icon.value.style.backgroundColor = status.color;
}

//watch(inpval, () => {
//    console.log("asdf", this.stati);
//})

onMounted(() => {
    selectStatus(props.stati[props.currentStatus], props.currentStatus);
})
</script>

<template>
    <div class="w-full relative">
        <input
            v-model="inpval"
            type="text"
            ref="input"
            class="selectStatus text-oteoText bg-oteoInputBG border-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm py-2 w-full"
            @blur="showResults = false"
            @click="showResults = !showResults"
        />
        <div class="selectStatusIcon" ref="icon"></div>
        <div
            v-if="showResults"
            class="bg-white border border-gray-200 rounded-sm absolute shadow-md mt-1 w-[363px]"
        >
            <div class="max-h-[200px] overflow-auto">
                <div
                    v-for="(status, index) in stati"
                    class="border-b cursor-pointer"
                    @mousedown.prevent
                    @click="selectStatus(status, index)"
                >
                    <div class="p-2">
                        <span
                            class="inline-block w-4 h-4 mr-2 rounded-full shadow"
                            :style="`background-color:${ status.color }`"
                        ></span>
                         {{ status.text }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
